import { jsx, jsxs } from "react/jsx-runtime";
import { __css, mergeClasses, tokens } from "@fluentui/react-components";
import { useId } from "react";
import { box } from "../../shell/styles.js";
import { layout, typeScale } from "../../theme/tokens.js";
const useStyles = __css({"card":{"B7ck84d":"f1ewtqcl","mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Belr9w4":"f1noh358","Bgto7am":"fuzgk9b","Byoj8tv":0,"uwmqm3":0,"z189sj":0,"z8tnut":0,"B0ocmuz":"fop8ug2","De3pzq":"fxugw4r","Beyfa6y":0,"Bbmb7ep":0,"Btl43ni":0,"B7oj6ja":0,"Dimara":"f1o0qvyv","B4m11q7":"f32hy0g","rm1204":"fwyddsq","ijz38e":"f1ftuoky","tzxy30":"fgmlvap","Bwezv66":"fwl1lcr","Ctt3hk":"f1crbv9w","gggo0z":"fi15kbk","B834pou":"f1taw3pw","F1poyb":"foi3q75","Behc1zw":"f10zy6vx","uk9mye":"f1p2dij1","mbw9mh":"f1a566p","E5pizo":"f1whvlc6"},"header":{"mc9l5x":"f22iagw","Bt984gj":"f122n59","Brf1p80":"f1869bpl","i8kkvl":"f1xcgk68"},"title":{"Bo78w4l":0,"Cgygva":0,"yil37a":"f8ntp42","Be2twd7":"f4ybsrx","Bg96gwp":"f8xlz6g","Bhrd7zp":"fl43uef","sj55zd":"f19n0e5"},"actions":{"mc9l5x":"f22iagw","Bt984gj":"f122n59","i8kkvl":"fsnqrgy","Bnnss6s":"fi64zpg"}});
const HEADINGS = { 1: "h1", 2: "h2", 3: "h3", 4: "h4", 5: "h5", 6: "h6" };
function SectionCard({
  title,
  headingLevel = 2,
  actions,
  children,
  className
}) {
  const styles = useStyles();
  const titleId = useId();
  const Heading = HEADINGS[headingLevel];
  if (!title) {
    return /* @__PURE__ */ jsxs("div", { className: mergeClasses(styles.card, className), children: [
      actions ? /* @__PURE__ */ jsx("div", { className: mergeClasses(styles.header, styles.actions), children: actions }) : null,
      children
    ] });
  }
  return /* @__PURE__ */ jsxs("section", { "aria-labelledby": titleId, className: mergeClasses(styles.card, className), children: [
    /* @__PURE__ */ jsxs("div", { className: styles.header, children: [
      /* @__PURE__ */ jsx(Heading, { id: titleId, className: styles.title, children: title }),
      actions ? /* @__PURE__ */ jsx("div", { className: styles.actions, children: actions }) : null
    ] }),
    children
  ] });
}
export {
  SectionCard
};
//# sourceMappingURL=section-card.js.map

import "/opt/batiflow/app/packages/ui/dist/components/section-card/section-card.griffel.css";